export default {
  namespaced: true,
  state: {
    // The Invites currently visible
    active: [],
    // Used to indicate when waiting on the server
    loading: false,
    // Token source used to abandon requests when navigating away
    source: null,
    // The search string being applied
    search: '',
    // What filters are currently applied
    filters: {},
    // The total records matching the filter according to the server (for pagination)
    total: 0,
    // The current page being viewed and its size
    page: 1,
    rowsPerPage: 25,
    // Sorting
    sort: {
      by: 'updatedAt',
      descending: false
    }
  },
  getters: {
    find: state => id => state.all.find(invite => invite.id == id)
  },
  mutations: {
    seed(state, source) {
      state.source = source
    },
    setActive(
      state,
      {
        items = [],
        page = 1,
        per = 25,
        total = 0,
        search = null,
        sort = { by: 'updatedAt', descending: true },
        filters = {}
      }
    ) {
      state.search = search
      state.active = items
      state.sort = sort
      state.filters = filters
      state.page = page
      state.rowsPerPage = per
      state.total = total
      state.loading = false
    },
    set(state, invite) {
      state.active = state.active.filter(o => o.id != invite.id)
      state.active.push(invite)
    },
    remove(state, id) {
      state.active = state.active.filter(o => o.id != id)
    }
  },
  actions: {
    abandon({ state }, reason) {
      if (state.source) {
        state.source.cancel(reason)
        state.source = null
      }
    },
    search(
      { commit, state },
      { search = '', page = 1, rowsPerPage = 25, sortBy = 'updatedAt', descending = true, filters = {} }
    ) {
      this.$authorize('list', 'Invite')

      const params = {
        search: search,
        page: page,
        per: rowsPerPage,
        sort: `${sortBy} ${descending ? 'DESC' : 'ASC'}`,
        ...filters
      }

      state.loading = true
      return Vue.$http
        .get('admin/invites', { params, cancelToken: state.source.token })
        .then(response => commit('setActive', response.data), error => (state.loading = false))
    },
    fetch({ commit }, id) {
      this.$authorize('read', 'Invite')

      return Vue.$http
        .get(`admin/invites/${id}`, { cancelToken: state.source.token })
        .then(response => commit('set', response.data))
    },
    create({ commit, state }, invite) {
      this.$authorize('create', 'Invite')

      return Vue.$http.post('admin/invites', { invite, cancelToken: state.source.token }).then(
        response => {
          commit('set', response.data)
          return response.data
        },
        error => Object.assign(invite, error.response.data)
      )
    }
  }
}
